/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_Group_WorkInputs */

const en_portalframe_group_work = /** @type {(inputs: Portalframe_Group_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your projects`)
};

/** @type {(inputs: Portalframe_Group_WorkInputs) => LocalizedString} */
const ar_portalframe_group_work = en_portalframe_group_work;

/** @type {(inputs: Portalframe_Group_WorkInputs) => LocalizedString} */
const he_portalframe_group_work = en_portalframe_group_work;

/** @type {(inputs: Portalframe_Group_WorkInputs) => LocalizedString} */
const ur_portalframe_group_work = en_portalframe_group_work;

/** @type {(inputs: Portalframe_Group_WorkInputs) => LocalizedString} */
const es_portalframe_group_work = en_portalframe_group_work;

/** @type {(inputs: Portalframe_Group_WorkInputs) => LocalizedString} */
const fr_portalframe_group_work = en_portalframe_group_work;

/** @type {(inputs: Portalframe_Group_WorkInputs) => LocalizedString} */
const de_portalframe_group_work = en_portalframe_group_work;

/** @type {(inputs: Portalframe_Group_WorkInputs) => LocalizedString} */
const pt_portalframe_group_work = en_portalframe_group_work;

/** @type {(inputs: Portalframe_Group_WorkInputs) => LocalizedString} */
const hi_portalframe_group_work = en_portalframe_group_work;

/** @type {(inputs: Portalframe_Group_WorkInputs) => LocalizedString} */
const bn_portalframe_group_work = en_portalframe_group_work;

/**
* | output |
* | --- |
* | "Your projects" |
*
* @param {Portalframe_Group_WorkInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_group_work = /** @type {((inputs?: Portalframe_Group_WorkInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_Group_WorkInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_group_work(inputs)
	if (locale === "he") return he_portalframe_group_work(inputs)
	if (locale === "ur") return ur_portalframe_group_work(inputs)
	if (locale === "es") return es_portalframe_group_work(inputs)
	if (locale === "fr") return fr_portalframe_group_work(inputs)
	if (locale === "de") return de_portalframe_group_work(inputs)
	if (locale === "pt") return pt_portalframe_group_work(inputs)
	if (locale === "hi") return hi_portalframe_group_work(inputs)
	if (locale === "bn") return bn_portalframe_group_work(inputs)
	return /** @type {LocalizedString} */ ("Your projects")
});